import { useContext } from 'react';

import { AddressSearchV2 } from '@selina-finance/ui';

import { ApplicationContext } from '@App/contexts/Application';
import AddressView from '@Components/AddressView/AddressView';
import { BUILDING_IDENTIFIER_FIELDS } from '@Shared/constants';
import { getAddressLine1 } from '@Shared/helpers/address';
import { getFormHelpers } from '@Shared/helpers/input';
import { EditButton } from '@Views/eligibility/addressRepeaterView/views/AddressSection/EditButton';
import { AddressValue } from '@src/shared/types';

interface IAddressViewProps {
    index: number;
    notTouched: boolean;
    isEdit: boolean;
    addressFieldName: string;
    formItems: any;
    formikProps: any;
    onEditButtonClick(): void;
}

export const AddressSection = ({
    index,
    notTouched,
    isEdit,
    addressFieldName,
    formItems,
    formikProps,
    onEditButtonClick,
}: IAddressViewProps) => {
    const { postcodeAddresses, fetchAddressesByPostcode } =
        useContext(ApplicationContext);
    const addressItemName = `${addressFieldName}[${index}]`;

    const { getProps, getError } = getFormHelpers(formItems, formikProps);

    const getAddressErrors = () => {
        const errors = getError(`${addressItemName}.address`, notTouched);

        if (!errors || typeof errors === 'string') {
            return errors;
        }

        const addressErrors = { ...errors };

        BUILDING_IDENTIFIER_FIELDS.forEach((field) => {
            if (addressErrors[field]) {
                addressErrors[field] = true;
            }
        });

        return addressErrors;
    };

    const value = getProps(
        `${addressItemName}.address`,
        `${addressFieldName}.address`,
    ).value as AddressValue;

    const currentAddress = formikProps.values.addresses[index].address;

    return (
        <div>
            {isEdit ? (
                <>
                    <AddressSearchV2
                        name={`${addressItemName}.address`}
                        value={currentAddress ?? ''}
                        className='mp-mask'
                        postcodeAddresses={postcodeAddresses}
                        fetchAddressesByPostcode={fetchAddressesByPostcode}
                        onChange={(e) => {
                            const values = e.currentTarget.value as any;

                            formikProps.setFieldValue(
                                `${addressItemName}.address`,
                                {
                                    line1: getAddressLine1(values),
                                    subBuildingName: values?.subBuildingName,
                                    streetName: values?.streetName,
                                    line2: '',
                                    city: values?.city,
                                    postcode: values?.postcode,
                                    country: values?.country,
                                    county: values?.county,
                                    buildingNumber: values?.buildingNumber,
                                    buildingName: values?.buildingName,
                                    uprn: values?.uprn,
                                    udprn: values?.udprn,
                                    isSaved: currentAddress?.isSaved ?? false,
                                },
                            );
                        }}
                        onBlur={formikProps.handleBlur}
                        errors={getAddressErrors()}
                    />
                </>
            ) : (
                <AddressView address={value} variant='extended' />
            )}
            {!isEdit && <EditButton onEditButtonClick={onEditButtonClick} />}
        </div>
    );
};
